import { HallBaseInfo, Country } from "./types";

/**
 * Returns the information of the country associated with the given hall.
 *
 * @export
 * @param {HallBaseInfo} hall
 * @returns {Country}
 */
export function getCountryOfHall(hall: HallBaseInfo): Country {
    return hall.subsidiary.country;
}

/**
 * Returns the short code for the country of the given hall.
 *
 * @export
 * @param {HallBaseInfo} hall
 * @returns {string} - Short code
 */
export function getCountryCodeOfHall(hall: HallBaseInfo): string {
    return getCountryOfHall(hall).code;
}
